import React, { useEffect, useState } from 'react';
import Icon from '../AppIcon';

const SIZE_CLASSES = {
  sm: 'h-14 w-14',
  md: 'h-16 w-16 sm:h-20 sm:w-20',
  lg: 'h-20 w-20 sm:h-24 sm:w-24',
};

const ItemThumbnail = ({
  src,
  alt,
  size = 'md',
  fallbackIcon = 'ImageOff',
  className = '',
}) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [src]);

  return (
    <div className={`flex flex-shrink-0 items-center justify-center overflow-hidden rounded-lg bg-muted ${SIZE_CLASSES[size] || SIZE_CLASSES.md} ${className}`}>
      {src && !hasError ? (
        <img
          src={src}
          alt={alt || 'Item image'}
          className="h-full w-full object-cover"
          loading="lazy"
          onError={() => setHasError(true)}
        />
      ) : (
        <Icon name={fallbackIcon} size={24} color="var(--color-muted-foreground)" className="opacity-70" />
      )}
    </div>
  );
};

export default ItemThumbnail;
